import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ExternalSettings } from '../../../services/external-settings/external-settings.interface';
import { ExternalSettingsService } from '../../../services/external-settings/external-settings.service';
import { ResponsiveDesignService } from '../../../services/responsive-design/responsive-design.service';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';

/** Result of the RESET_PASSWORD App Authenticator choice dialog. */
export type AppAuthenticatorResetPasswordChoice = 'sendNotification' | 'sendCode' | 'cancel';

@Component({
  selector: 'app-app-authenticator-reset-password',
  templateUrl: './app-authenticator-reset-password.component.html',
  styleUrls: ['./app-authenticator-reset-password.component.less'],
  standalone: false,
})
export class AppAuthenticatorResetPasswordComponent implements OnInit {

  UIUtilityService: any = UIUtilityService;
  externalSettings!: ExternalSettings;

  constructor(
    public dialogRef: MatDialogRef<AppAuthenticatorResetPasswordComponent, AppAuthenticatorResetPasswordChoice>,
    private srvES: ExternalSettingsService,
    protected srvRpDesign: ResponsiveDesignService,
  ) { }

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((settings) => {
      this.externalSettings = settings;
    });
  }

  onSendNotification(): void {
    this.dialogRef.close('sendNotification');
  }

  onSendCode(): void {
    this.dialogRef.close('sendCode');
  }

  onCancel(): void {
    this.dialogRef.close('cancel');
  }
}
